export type VTooltipEvent = Event & {
  closePopover: boolean;
  closeAllPopover: boolean;
  currentTarget: EventTarget & {
    $_vclosepopover_touch: boolean;
    $_closePopoverModifiers: any;
  };
};

export const closePopover = (event: VTooltipEvent) => {
  const el = event.currentTarget;
  event.closePopover = !el?.$_vclosepopover_touch;
  event.closeAllPopover =
    el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
};
